const excelStyle = {
    borderThin : {
      top:{style:"thin", color:"000000"}, 
      right:{style:"thin", color:"000000"}, 
      left:{style:"thin", color:"000000"}, 
      bottom:{style:"thin", color:"000000"}
    },
    borderThick : {
      top:{style:"thick", color:"000000"}, 
      right:{style:"thick", color:"000000"}, 
      left:{style:"thick", color:"000000"}, 
      bottom:{style:"thick", color:"000000"}
    }
  };
  
  export default excelStyle;